import React, { useState } from 'react'

import {
  Container, Title, Date, Message,
} from './styles'

import IProps from './props'

import formatTimestamp from '../../../../helpers/helper-format-timestamp'

const Notification = ({ title, date, message }: IProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleTitleClick = () => {
    setIsVisible(!isVisible)
  }

  return (
    <Container>
      <Title onClick={handleTitleClick}>{title}</Title>
      <Date>{formatTimestamp(date)}</Date>
      <Message isVisible={isVisible}>{message}</Message>
    </Container>
  )
}

export default Notification
